// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1TcK9","title":"Images45_title__mpdp0","images":"Images45_images__1Ih1f"};